var rate_content_resource = (function ($) {

    var _init = function () {
        $('.star').on('click', function () {
            if ($(this).parent().hasClass('logged-out')) {
                return;
            }
            
            let rating = $(this).data('value');
            let content_resource_id = $('#star-rating').data('content-resource-id');

            rate_resource(rating, content_resource_id);
        });
    };

    var rate_resource = function (rating, content_resource_id) {
        const stars = $('.star');

        stars.each(function (index) {
            $(this).toggleClass('filled', index < rating);
        });

        let data = {
            nonce: scriptData.vibe_eos_rateContentResource_ajax_rate_nonce,
            action: 'vibe_eos_rateContentResource_ajax_rate',
            rating: rating,
            content_resource_id: content_resource_id
        }

        $.post(scriptData.ajaxURL, data, function (res) {
            // TODO: Maybe update data on rating?
            // TODO: Or at least show a confirmation message to show you have rated
            if (res.success) {
                console.log('Successfully rated ' + res.rating)
            } else {
                console.log('Error: ' + res.message);
            }
        });
    }

    $(document).ready(_init);

    return {};

})(jQuery);

module.exports = rate_content_resource;